import { render, staticRenderFns } from "./PromoTemplateA4MSR.vue?vue&type=template&id=1d2e05ba"
import script from "./PromoTemplateA4MSR.vue?vue&type=script&lang=js"
export * from "./PromoTemplateA4MSR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports